import React, { useState, useEffect, useRef } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';
import { Link as LinkRouter } from 'react-router-dom';
import { AiOutlinePlus, AiFillEdit, AiFillDelete } from 'react-icons/ai'
// import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import { AiOutlineRollback } from "react-icons/ai";
import { useHistory, useParams } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import InputMask from 'react-input-mask';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
	ClassicEditor,
	Bold,
	Essentials,
	Heading,
	Indent,
	IndentBlock,
	Italic,
	Link,
	List,
	MediaEmbed,
	Paragraph,
	Table,
	Undo
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import dayjs from "dayjs";
import { RiSettings2Fill } from 'react-icons/ri';
import 'bootstrap/dist/css/bootstrap.min.css';

function Addcontent() {
	const history = useHistory();
	const [pages, setPages] = useState([]);
	const [sections, setSections] = useState([]);
	const [error, setError] = useState(null);
	const [errorForm, setErrorForm] = useState([]);
	const [validated, setValidated] = useState(false);
	const [defaultSelectedPage, setDefaultSelectedPage] = useState({});
	const [defaultSelectedSection, setDefaultSelectedSection] = useState({});

	const today = new Date();
	
	const [startDate, setStartDate] = useState(new Date());
	
	const [formData, setFormData] = useState({
		contentPage: '',
		section: '',
		title: '',
		descriptions: '',
		contents: '',
	});

	const editorDescRef = useRef();

	const editorContentRef = useRef();

	const pageList = [
		{
			title: 'About Us',
		},
		{
			title: 'Careers',
		},
		{
			title: 'Contact',
		},
		{
			title: 'History',
		},
		{
			title: 'Home',
		},
		{
			title: 'Leadership',
		},
		{
			title: 'News',
		},
		{
			title: 'Privacy',
		},
		{
			title: 'Projects',
		},
		{
			title: 'Safety',
		},
		{
			title: 'Services',
		},
		{
			title: 'Terms',
		},
		{
			title: 'Thinker',
		},
		{
			title: 'Vision and Mission',
		},
	]

	const sectionList =[
		{
			title: 'Company Profile'
		},
		{
			title: 'A bold direction'
		},
		{
			title: 'About Us'
		},
		{
			title: 'Career Opportunities'
		},
		{
			title: 'Contents'
		},
		{
			title: 'Facts'
		},
		{
			title: 'Flexible'
		},
		{
			title: 'Growing'
		},
		{
			title: 'History Item'
		},
		{
			title: 'Innovative'
		},
		{
			title: 'Insights'
		},
		{
			title: 'Item Client'
		},
		{
			title: 'Item Contact'
		},
		{
			title: 'Item Content'
		},
		{
			title: 'Item Leadership'
		},
		{
			title: 'Item News'
		},
		{
			title: 'Leadership'
		},
		{
			title: 'News'
		},
		{
			title: 'Our Client'
		},
		{
			title: 'Our Commitment To Community'
		},
		{
			title: 'Our Commitments'
		},
		{
			title: 'Our Core Values'
		},
		{
			title: 'Our Focus'
		},
		{
			title: 'Our History'
		},
		{
			title: 'Our Mission'
		},
		{
			title: 'Our Position'
		},
		{
			title: 'Our Purpose'
		},
		{
			title: 'Our Vision'
		},
		{
			title: 'Projects'
		},
		{
			title: 'Quality'
		},
		{
			title: 'Safety'
		},
		{
			title: 'Services'
		},
		{
			title: 'Slogan'
		},
		{
			title: 'Sustainability'
		},
		{
			title: 'Thinker'
		},
		{
			title: 'Who We Are'
		},
	]

	useEffect(() => {
		getPages(defaultSelectedPage)
		getSections(defaultSelectedSection)
	}, []);

	const getPages = (selectedPage) => {
		for( let i=0; i < pageList.length; i++)
		{
			var selected = false
			if( pageList[i].title === selectedPage )
			{
					selected = true;
			}
			pageList[i].selected = selected
		}
		console.log(pageList);
		setPages(pageList);
	}

	const getSections = (selectedSection) => {
		for( let i=0; i < sectionList.length; i++)
		{
			var selected = false
			if( sectionList[i].title === selectedSection )
			{
					sectionList[i].selected = true;
			}
		}
		setSections(sectionList);
	}

	const onChangeEditorDesc = (e) => {
		setFormData({...formData, ['descriptions']: e})
	}

	const onChangeEditorContent = (e) => {
		setFormData({...formData, ['contents']: e})
	}

	const handleChange = (e) => {
		// console.log(e)
		const key = e.target.name;
		const value = e.target.value;
		setFormData({...formData, [key]: value})
	}

	const handleChangeSelect = (e) => {
		const key = e.target.name;
		const value = e.target.value;
		setFormData({...formData, [key]: value})
	}
	
	const handleSubmit = (req) => {
		req.preventDefault();
		const form = req.currentTarget;
		if (form.checkValidity() === false) {
			req.preventDefault();
			req.stopPropagation();
			return;
		}

		setValidated(true);
		var data = new FormData(form);
		let formObject = Object.fromEntries(data.entries());
		formObject.descriptions = formData.descriptions;
		formObject.contents = formData.contents;
		
		Api().post(`contents`, formObject)
		.then((response) => response)
		.then((data) => {
			if( data.status === 200 || data.status === 201){
				history.push('/contents');
			}
		})
		.catch((err) => {
		});
	};
		
	return (
		<>
			<div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
				<DefaultLayout />
				{/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
				<main>
					<div className="content-header">
						<Container fluid>
							<Row className="">
								<Col sm={4}>
									<h1 className="m-0">Add Content</h1>
								</Col>
								<Col sm={2}>
									{ checkMenu('contents') &&
										<LinkRouter to="/contents"><Button variant="outline-primary" className="btn-upload"><AiOutlineRollback /> Back</Button></LinkRouter>
									}
								</Col>
								<Col sm={3}>
								</Col>
								<Col sm={3}>
									<div className="date-time float-sm-right">
											{ moment().format('dddd, DD MMMM YYYY') }
									</div>
								</Col>
							</Row>
						</Container>
					</div>
							
					<div className="content">
						<Container fluid>
							<Row>
								<Col lg={12}>
									<Card className="content-list">
										<Card.Body>
											<Col md="12">
												<Form noValidate validated={validated} onSubmit={handleSubmit}>
													<Row className="mb-3">
														<Form.Group as={Col} md="4" controlId="validationCustom08">
															<Form.Label>Content Page</Form.Label>
															<Form.Control
																required
																as="select"
																name="contentPage"
																defaultValue={defaultSelectedPage}
																// value={defaultSelectedPage}
																onChange={handleChangeSelect}
															>
																<option value="">Select Content Page</option>
																{
																	pages.map((item, i) => (
																		<option key={i} value={item.title} selected={item.selected}>{item.title}</option>
																	))
																}
															</Form.Control>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom08">
															<Form.Label>Sections</Form.Label>
															<Form.Control
																// required
																as="select"
																name="section"
																defaultValue={defaultSelectedSection}
																// value={defaultSelectedSection}
																onChange={handleChangeSelect}
															>
																<option value="">Select Section</option>
																{
																	sections.map((item, i) => (
																		<option key={i} value={item.title} selected={item.selected}>{item.title}</option>
																	))
																}
															</Form.Control>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Title</Form.Label>
															<Form.Control
																required
																type="textarea"
																name="title"
																defaultValue={formData.title || ''}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Descriptions</Form.Label>
															<CKEditor
																editor={ ClassicEditor }
																config={ {
																	toolbar: [
																		'undo', 'redo', '|',
																		'heading', '|', 'bold', 'italic', '|',
																		'link', 'insertTable', 'mediaEmbed', '|',
																		'bulletedList', 'numberedList', 'indent', 'outdent'
																	],
																	licenseKey: 'GPL',
																	plugins: [
																		Bold,
																		Essentials,
																		Heading,
																		Indent,
																		IndentBlock,
																		Italic,
																		Link,
																		List,
																		MediaEmbed,
																		Paragraph,
																		Table,
																		Undo
																	],
																	root: {
																		initialData: formData.descriptions || '',
																		placeholder: '',
																	},
																} }
																onReady={ (editor) => {
																	editorDescRef.current = editor;
																} }
																data={ formData.descriptions || '' }
																onChange={ () => {
																	onChangeEditorDesc( editorDescRef.current?.getData() );
																} }
															/>
														</Form.Group>
                            <input type='hidden' defaultValue={formData.descriptions} name="descriptions" />	
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Contents</Form.Label>
															<CKEditor
																editor={ ClassicEditor }
																config={ {
																	toolbar: [
																		'undo', 'redo', '|',
																		'heading', '|', 'bold', 'italic', '|',
																		'link', 'insertTable', 'mediaEmbed', '|',
																		'bulletedList', 'numberedList', 'indent', 'outdent'
																	],
																	licenseKey: 'GPL',
																	plugins: [
																		Bold,
																		Essentials,
																		Heading,
																		Indent,
																		IndentBlock,
																		Italic,
																		Link,
																		List,
																		MediaEmbed,
																		Paragraph,
																		Table,
																		Undo
																	],
																	root: {
																		initialData: formData.contents || '',
																		placeholder: '',
																	},
																} }
																onReady={ (editor) => {
																	editorContentRef.current = editor;
																} }
																data={ formData.contents || '' }
																onChange={ () => {
																	onChangeEditorContent( editorContentRef.current?.getData() );
																} }
															/>
														</Form.Group>	
													</Row>
													{error && 
														<Alert variant="danger">
															{error}
														</Alert>
													}
													<Button type="submit">Save</Button>
												</Form>
											</Col>
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>
					</div>
				</main>
			</div>
			<Footer />
		</>
	)
}
export default Addcontent